import React from 'react';
import { Link } from 'react-router-dom';
import './ArticleCard.css';

/**
 * ArticleCard Component
 * Preview card for help articles
 */
const ArticleCard = ({ title, excerpt, category, route, readTime }) => {
  return (
    <Link to={route} className="article-card">
      <div className="article-card-header">
        <span className="article-card-category">{category}</span>
        {readTime && (
          <span className="article-card-time">{readTime} min read</span>
        )}
      </div>
      <h3 className="article-card-title">{title}</h3>
      {excerpt && (
        <p className="article-card-excerpt">{excerpt}</p>
      )}
    </Link>
  );
};

export default ArticleCard;
